<div class="epic-lookup-modal">
  <h2 class="epic-lookup-title">
    Search {{ type === 'Provider' ? 'Provider' : 'Patient' }} in <span class="epic-text">EPIC</span>
  </h2>

  <form class="epic-lookup-form" (ngSubmit)="search()">
    @if (isLoading) {
      <div class="spinner-container">
        <div class="spinner"></div>
        <p>Looking for {{ type === 'Provider' ? 'provider' : 'patient' }} records in EPIC...</p>
      </div>
    } @else if (isSaving) {
      <div class="spinner-container">
        <div class="spinner"></div>
        <p>Linking Graft and EPIC records...</p>
      </div>
    } @else if (successMessage) {
      <div class="success-container">
        <div class="text-center p-4">
          <i
            class="bi bi-check-circle-fill text-success"
            style="font-size: 4rem"
          ></i>
          <p class="mt-3 fs-5">{{ successMessage }}</p>
          <p class="mt-4">
            Closing in <strong>{{ countdown }}</strong> seconds...
          </p>
        </div>
      </div>
    } @else {
      <div
        class="epic-lookup-fields-container"
        [ngClass]="{ 'inline-form': hasResults() }"
      >
        @if (type === 'Provider') {
          <div class="form-group epic-lookup-field">
            <label for="fullName" class="epic-lookup-label">Name</label>
            <input
              id="fullName"
              type="text"
              name="fullName"
              class="form-control epic-lookup-input"
              [(ngModel)]="practitionerSearch.fullName"
              #fullName="ngModel"
              required
            />
            <div
              *ngIf="
                fullName.invalid &&
                (fullName.dirty || fullName.touched || submitted)
              "
              class="text-danger"
            >
              Name is required.
            </div>
          </div>
        } @else {
          <div class="form-group epic-lookup-field">
            <label for="firstName" class="epic-lookup-label">First Name</label>
            <input
              id="firstName"
              type="text"
              name="firstName"
              class="form-control epic-lookup-input"
              [(ngModel)]="patientSearch.firstName"
              #firstName="ngModel"
              required
            />
            <div
              *ngIf="
                firstName.invalid &&
                (firstName.dirty || firstName.touched || submitted)
              "
              class="text-danger"
            >
              First Name is required.
            </div>
          </div>

          <div class="form-group epic-lookup-field">
            <label for="lastName" class="epic-lookup-label">Last Name</label>
            <input
              id="lastName"
              type="text"
              name="lastName"
              class="form-control epic-lookup-input"
              [(ngModel)]="patientSearch.lastName"
              #lastName="ngModel"
              required
            />
            <div
              *ngIf="
                lastName.invalid &&
                (lastName.dirty || lastName.touched || submitted)
              "
              class="text-danger"
            >
              Last Name is required.
            </div>
          </div>
        }

        @if (type !== 'Provider') {
          <div class="form-group epic-lookup-field">
            <label for="dateOfBirth" class="epic-lookup-label">Date of Birth</label>
            <div class="input-group">
              <input
                id="dateOfBirth"
                class="form-control epic-date-input"
                placeholder="mm/dd/yyyy"
                name="dateOfBirth"
                ngbDatepicker
                #d="ngbDatepicker"
                [(ngModel)]="patientSearch.dateOfBirth"
                #dateOfBirth="ngModel"
                required
              />
              <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
                <i class="bi bi-calendar"></i>
              </button>
            </div>
            <div
              *ngIf="
                (dateOfBirth.invalid && (dateOfBirth.dirty || dateOfBirth.touched || submitted)) ||
                isDateOfBirthInvalid()
              "
              class="text-danger"
            >
              {{ isDateOfBirthInvalid() ? 'Date of Birth is invalid.' : 'Date of Birth is required.' }}
            </div>
          </div>
        }

      </div>
    }

    <div class="modal-footer epic-lookup-footer">
      @if (successMessage) {
        <!-- <button
          type="button"
          class="btn btn-secondary epic-lookup-btn epic-lookup-btn-cancel"
          (click)="close()"
          [disabled]="isSaving"
        >
          Close
        </button> -->
      } @else {
        <button
          type="button"
          class="btn btn-secondary epic-lookup-btn epic-lookup-btn-cancel"
          (click)="close()"
          [disabled]="isSaving"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary epic-lookup-btn epic-lookup-btn-search"
          [disabled]="isLoading || isSaving || isDateOfBirthInvalid()"
        >
          Search
        </button>
      }
    </div>
  </form>

  @if (this.submitted && !this.isLoading && !this.isSaving && searchResults && searchResults.length == 0) {
    <div class="no-results-message">
      No {{ type === 'Provider' ? 'provider' : 'patient' }} records found matching your current search criteria.
    </div>
  } @else if (
    searchResults &&
    searchResults.length > 0 &&
    !this.isLoading &&
    !this.isSaving &&
    !this.successMessage
  ) {
    @if (type === 'Provider') {
      <table class="table epic-lookup-results-table">
        <thead>
          <tr>
            <th>NPI</th>
            <th>Name</th>
            <th>Specialty</th>
            <th>Qualification</th>
            <th>Phone</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of searchResults">
            <td>{{ result.npi || "" }}</td>
            <td>{{ result.name || "" }}</td>
            <td>{{ result.specialty || "" }}</td>
            <td>{{ result.qualification || "" }}</td>
            <td>{{ getPhoneNumberString(result.phone) }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="selectRecord(result)"
              >
                Select
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    } @else {
      <table class="table epic-lookup-results-table">
        <thead>
          <tr>
            <th>MRN</th>
            <th>Name</th>
            <th>Date of Birth</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of searchResults">
            <td>{{ result.mrn }}</td>
            <td>{{ result.name }}</td>
            <td>{{ formatDateToMMDDYYYY(result.dateOfBirth) }}</td>
            <td>{{ getPhoneNumberString(result.phone) }}</td>
            <td>{{ result.email }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                (click)="selectRecord(result)"
              >
                Select
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    }
  }
</div>
